module.exports = {
      id: "paypal-with-error-usage",
      viewBox: "0 0 108 84",
      url: __webpack_public_path__ + "img/icons.09862bea.svg#paypal-with-error",
      toString: function () {
        return this.url;
      }
    }